import React, { useState } from "react";
import { Card, Button, Message, Menu } from "semantic-ui-react";
import { map } from "lodash";
import "./MisGrupos.css"; // Import the custom CSS file

export function MisGrupos({
  cursosDocente,
  cursosAsignadosTitulacion,
  calificarCurso,
  periodoSeleccionado,
}) {
  const [activeTab, setActiveTab] = useState("Grupos");

  const renderTabContent = () => {
    const cursos =
      activeTab === "Grupos" ? cursosDocente : cursosAsignadosTitulacion;
    return (
      <div>
        {cursos && cursos.length > 0 ? (
          <Card.Group centered>
            {map(cursos, (curso, index) => (
              <CursoCard
                key={index}
                curso={curso}
                calificarCurso={calificarCurso}
              />
            ))}
          </Card.Group>
        ) : (
          <Message
            info
            header={
              activeTab === "Grupos"
                ? "No tienes grupos asignados para este periodo"
                : "No tienes practicantes para este periodo"
            }
            content="Selecciona un periodo diferente para ver tus grupos/practicantes."
          />
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="pills-container">
        <Menu pointing secondary className="pills-menu">
          <Menu.Item
            name="Grupos"
            active={activeTab === "Grupos"}
            onClick={() => setActiveTab("Grupos")}
            className="pill"
          >
            <i className="users icon" />
            Grupos
          </Menu.Item>
          <Menu.Item
            name="Asesorados"
            active={activeTab === "Asesorados"}
            onClick={() => setActiveTab("Asesorados")}
            className="pill"
          >
            <i className="user graduate icon" />
            Asesorados
          </Menu.Item>
        </Menu>
      </div>
      {periodoSeleccionado ? (
        renderTabContent()
      ) : (
        <Message
          info
          header="Selecciona un periodo"
          content="Selecciona un periodo para ver tus grupos asignados."
        />
      )}
    </div>
  );
}

function CursoCard({ curso, calificarCurso }) {
  return (
    <Card style={{ marginBottom: "20px" }}>
      <Card.Content>
        <Card.Header className="tipoLetra">
          CLAVE: {curso.materia_data.clave_materia}
        </Card.Header>
        <Card.Meta>MATERIA: {curso.materia_data.nombre_materia}</Card.Meta>
        <Card.Description>
          Grupo: {curso.grupo_data.numero_grupo}
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div className="ui two buttons">
          <Button
            color="green"
            onClick={() => {
              calificarCurso(curso);
            }}
            className="tipoLetra"
          >
            Calificar
          </Button>
        </div>
      </Card.Content>
    </Card>
  );
}
